export const QuestPerk = ({ index, claimed, message, type }) => {
  const imageURLs = {
    gold: "https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2FIcon_HV_Resource_Gold_2.png?alt=media&token=b18097b0-407b-4668-88e1-fb7e4e2f3696",
    robux:
      "https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2FRobux_2019_Logo_gold.svg.png?alt=media&token=def71a22-9b87-409f-ad4c-f68a4fca9864",
    potion:
      "https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2FMagic_Item_Power_potion.png?alt=media&token=af882f44-96a2-4a63-8b26-b8d4a3239893",
    "Book of History":
      "https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2FMagic_Item_Book_of_Heroes.png?alt=media&token=fd103eaa-458c-4273-82eb-ff1fb3e0e624",
    "Book of Time Travel":
      "https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2FMagic_Item_Book_of_Everything.png?alt=media&token=a29e8976-ddcf-42bb-a4f0-9cf36114341e",
    "Book of Quest":
      "https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2FMagic_Item_Book_of_Troops.png?alt=media&token=bacec6ad-1da8-4386-9ffa-8adf91ae600b",
  };

  const imgSrc =
    type === "robux"
      ? imageURLs.robux
      : type === "potion"
      ? imageURLs.potion
      : type === "magicBook"
      ? imageURLs[message]
      : imageURLs.gold;

  return (
    <div
      style={{
        width: "100px",
        height: "fit-content",
        position: "absolute",
        // Important: Position based on the index and the PERK_WIDTH constant
        left: index * 200 + 200 + "px",
        top: "20px",
        padding: "10px",
        borderRadius: "8px",
        opacity: claimed ? "0.5" : "1",
        transition: "opacity 0.3s ease",
      }}
    >
      <div
        className="text-reward-number-gold"
        style={{
          color: "#ffcc33",
          fontSize: "24px",
          fontWeight: "900",
          width: "100px",
          textAlign: "center",
          textShadow: "#FFD700bb 0px 0px 10px",
        }}
      >
        <img
          src={imgSrc}
          alt="reward icon"
          style={{ height: "50px", margin: "-30px auto" }}
        />
      </div>

      <p
        style={{
          color: "#ffcc33",
          fontSize: "12px",
          lineHeight: "12px",
          margin: "30px auto",
          maxWidth: "100px",
          wordBreak: "break-word",
          textAlign: "center",
        }}
      >
        {message}
      </p>
    </div>
  );
};
